import React, { Component } from 'react'
import NumberFormat from 'react-number-format';
import { Link } from 'react-router-dom'
import { withRouter } from 'react-router';

class Cart extends Component {
    constructor(props) {
        super(props);
    }
    handleToCheckout = () => {
        let cart = this.props.cart;
        if( cart.products.length > 0 ){
            this.props.history.push('/checkout/'+cart.id);
        } else {
            alert('買い物かごに商品を入れてください。');
        }
    };
    render(){
        let cart = this.props.cart;
        let products = [];
        if( cart.products.length==0 ){
            products.push(<div key={0}>現在買い物かごに商品はありません。</div>);
        } else {
            for (let v of cart.products) {
                products.push(
                    <div key={v.id} className="col-md-6">
                        <div className="column-cart mb-2">
                            <div className="row">
                                <div className="col-3">
                                    <div className="text-center">
                                        <img src={v.image_url} className="img-fluid mt-3"/>
                                    </div>
                                </div>
                                <div className="col-9 padding-left-none">
                                    <div className="title-item-cart">
                                        {v.name}
                                    </div>
                                    <div className="update-quantity">
                                        <div className="float-left">
                                            <ul className="form-update-quantity">
                                                <li className={(this.props.readOnly? 'd-none': '')}>
                                                    <button className="btn btn-primary btn-custom btn-sm" onClick={()=>this.props.addProductNum(v, 1)}>
                                                        +
                                                    </button>
                                                </li>
                                                <li>
                                                    <input type="number" name="quantity" min="1" value={v.num} readOnly/>
                                                </li>
                                                <li className={(this.props.readOnly? 'd-none': '')}>
                                                    <button className="btn btn-primary btn-custom btn-sm" onClick={()=>this.props.addProductNum(v, -1)}>
                                                        -
                                                    </button>
                                                </li>
                                                <li className={(this.props.readOnly? 'd-none': '')}>
                                                    <button className="btn btn-custom btn-secondary btn-sm" onClick={()=>this.props.removeCart(v)}>
                                                        削除
                                                    </button>
                                                </li>
                                            </ul>
                                        </div>
                                        <div className="float-right">
                                            <div className="price-item-product">
                                                販売価格（税込）
                                                <span><NumberFormat value={v.price} displayType={'text'} thousandSeparator={true}/>円</span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="column-cart-mb mt-4">
                            <div className="row">
                                <div className="col-3">
                                    <div className="text-center">
                                        <img src="/images/product-01.png" className="img-fluid"/>
                                    </div>
                                </div>
                                <div className="col-9 padding-left-none">
                                    <div className="title-item-cart">
                                        {v.name}
                                    </div>
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-12">
                                    <div className="update-quantity">
                                        <div className="float-left">
                                            <ul className="form-update-quantity">
                                                <li className={(this.props.readOnly? 'd-none': '')}>
                                                    <button className="btn btn-primary btn-custom btn-sm" onClick={()=>this.props.addProductNum(v, 1)}>
                                                        +
                                                    </button>
                                                </li>
                                                <li>
                                                    <input type="number" name="quantity" min="1" value={v.num} readOnly/>
                                                </li>
                                                <li className={(this.props.readOnly? 'd-none': '')}>
                                                    <button className="btn btn-primary btn-custom btn-sm" onClick={()=>this.props.addProductNum(v, -1)}>
                                                        -
                                                    </button>
                                                </li>
                                                <li className={(this.props.readOnly? 'd-none': '')}>
                                                    <button className="btn btn-custom btn-secondary btn-sm" onClick={()=>this.props.removeCart(v)}>
                                                        削除
                                                    </button>
                                                </li>
                                            </ul>
                                        </div>
                                        <div className="float-right">
                                            <div className="price-item-product">
                                                販売価格（税込）
                                                <span><NumberFormat value={v.price} displayType={'text'} thousandSeparator={true}/>円</span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                );
            }
        }
        return(
            <div id="cart-content" className="cart-content">
                <div className="container">
                    <div className="container">
                        <div className="title-cart-content clearfix">
                            <div className="float-left">
                                <img src="/images/icon_06.png" className="img-fluid"/>
                            </div>
                            <div className="float-left">
                                <div className="left-title-cart">買い物かご</div>
                            </div>
                        </div>
                        <div className="row">
                            {products}
                        </div>
                        <div className={"total-amount clearfix "}>
                            <div className="float-left">
                                合計 <span><NumberFormat value={cart.total} displayType={'text'} thousandSeparator={true}/>円</span>
                            </div>
                            <div className={"float-right "+(this.props.readOnly? 'd-none': '')}>
                                <a className={"btn-payment "} onClick={this.handleToCheckout}>
                                    購入画面へ進む
                                </a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default withRouter(Cart)